import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  getMyUserGroupPage,
  exportExcel,
  testTrans1,
} from '@/api/asalarmanalysisresultserv'

export default {
  state: {
    state_AsAlarmAnalysisResult_GetAllResult: null,
    state_AsAlarmAnalysisResult_SearchByNameResult: null,
    state_AsAlarmAnalysisResult_GetPageResult: null,
    state_AsAlarmAnalysisResult_GetDetailResult: null,
    state_AsAlarmAnalysisResult_GetMyUserGroupPageResult: null,
    state_AsAlarmAnalysisResult_ExportExcelResult: null,
    state_AsAlarmAnalysisResult_TestTrans1Result: null,
  },
  mutations: {
    SET_ASALARMANALYSISRESULT_GETALL_RESULT: (state, rst) => {
      state.state_AsAlarmAnalysisResult_GetAllResult = rst;
    },
    SET_ASALARMANALYSISRESULT_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_AsAlarmAnalysisResult_SearchByNameResult = rst;
    },
    SET_ASALARMANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_AsAlarmAnalysisResult_GetPageResult = rst;
    },
    SET_ASALARMANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_AsAlarmAnalysisResult_GetDetailResult = rst;
    },
    SET_ASALARMANALYSISRESULT_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_AsAlarmAnalysisResult_GetMyUserGroupPageResult = rst;
    },
    SET_ASALARMANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_AsAlarmAnalysisResult_ExportExcelResult = rst;
    },
    SET_ASALARMANALYSISRESULT_TESTTRANS1_RESULT: (state, rst) => {
      state.state_AsAlarmAnalysisResult_TestTrans1Result = rst;
    },
  },
  actions: {
    AsAlarmAnalysisResultServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ASALARMANALYSISRESULT_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ASALARMANALYSISRESULT_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AsAlarmAnalysisResultServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ASALARMANALYSISRESULT_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ASALARMANALYSISRESULT_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AsAlarmAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ASALARMANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ASALARMANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AsAlarmAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ASALARMANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ASALARMANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AsAlarmAnalysisResultServ_GetMyUserGroupPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ASALARMANALYSISRESULT_GETMYUSERGROUPPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ASALARMANALYSISRESULT_GETMYUSERGROUPPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AsAlarmAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ASALARMANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ASALARMANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AsAlarmAnalysisResultServ_TestTrans1({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        testTrans1(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ASALARMANALYSISRESULT_TESTTRANS1_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ASALARMANALYSISRESULT_TESTTRANS1_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_AsAlarmAnalysisResult_GetAllResult: state => {
      return state.state_AsAlarmAnalysisResult_GetAllResult;
    },
    get_AsAlarmAnalysisResult_SearchByNameResult: state => {
      return state.state_AsAlarmAnalysisResult_SearchByNameResult;
    },
    get_AsAlarmAnalysisResult_GetPageResult: state => {
      return state.state_AsAlarmAnalysisResult_GetPageResult;
    },
    get_AsAlarmAnalysisResult_GetDetailResult: state => {
      return state.state_AsAlarmAnalysisResult_GetDetailResult;
    },
    get_AsAlarmAnalysisResult_GetMyUserGroupPageResult: state => {
      return state.state_AsAlarmAnalysisResult_GetMyUserGroupPageResult;
    },
    get_AsAlarmAnalysisResult_ExportExcelResult: state => {
      return state.state_AsAlarmAnalysisResult_ExportExcelResult;
    },
    get_AsAlarmAnalysisResult_TestTrans1Result: state => {
      return state.state_AsAlarmAnalysisResult_TestTrans1Result;
    },
  }
}